import { StyleProp, ViewStyle } from "react-native";
import Touchable from "src/components/Touchable";
import IconInstagram from "src/icons/IconInstagram";

const InstagramBadge = ({
	instagramUsername,
	style,
}: {
	instagramUsername: string | null | undefined;
	style?: StyleProp<ViewStyle>;
}) => {
	return instagramUsername ? (
		<Touchable
			href={`https://www.instagram.com/${instagramUsername}`}
			linkUrlScheme={`instagram://user?username=${instagramUsername}`}
			target="_blank"
			style={style}
		>
			<IconInstagram size={20} />
		</Touchable>
	) : null;
};
export default InstagramBadge;
